import { createGlobalStyle, css } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  ${({ theme }) => css`
    html,
    body,
    #__next {
      height: 100%;
    }

    body {
      font-family: ${theme.font.quicksand};
      font-size: ${theme.font.sizes.medium};
      background-color: ${theme.colors.mainBg};
      color: ${theme.colors.body};
      -webkit-font-smoothing: antialiased;
      .z-50 {
        z-index: 101;
      }
    }

    .Toastify__toast {
      pointer-events: auto !important;
    }

    [data-slot="dialog-overlay"] {
      animation: none !important;     
      transition: none !important;    
      opacity: 1 !important;          
    }
  `}
`

export default GlobalStyles
